import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Autocomplete,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
  Button,
  CircularProgress,
  InputLabel
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setFormData } from "../../../store/redux/customForms";
import { convertFormsToJson } from "../../../util/utilfunctions/utilFunctions";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
      maxHeight: '50px',
      fontSize: '18px !important',
      paddingTop: 0,
      paddingBottom: 0,
      marginTop:"0px"
    },
    '& .MuiFormControl-fullWidth': {
        marginTop:"0px"
      },
    '& input': {
      padding: '15px 12px',
      fontSize: '16px',
      lineHeight: '50px !important',
    },
    '& label': {
      fontSize: '14px',
    //   top: '-5px',
    },
    '& label.Mui-focused, & label.MuiInputLabel-shrink': {
      top: 0,
      fontSize: '18px',
    },
  }));
  
const CustomDatePicker = styled(DatePicker)({
    '& .MuiInputBase-root': {
      maxHeight: '35px', 
      fontSize: '14px',
    },
})

const CustomLoansForm = ({ formName, onSubmit, buttonText = "Submit", loadingButtonText = "Submitting...", loading = false, handleLoanSubProductChange, loanTerms, loanType, isGlobalPayment, totalOutstandingAmount, selectedLoan, initialValues, totalLateFees, isCreate, isEdit, handleLoanTypeChange, isLoanProduct, getUserExternalAcctBalance, externalBalance, verifyLangTagId }) => {
    const [fields, setFields] = useState([]);
    const [formValues, setFormValues] = useState({});
    const [errors, setErrors] = useState({});
    const [visibleFields, setVisibleFields] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const dispatch = useDispatch();
     console.log("initialValues-----------",initialValues)
     //console.log("isCreate-----------",isCreate)
     //console.log("formName-----------",formName)

    useEffect(() => {
        const fetchForm = async () => {
            try {
                const response = await fetch(`/forms/${formName}.json`);
                const formResponseData = await response.json();
                const convertedForms = convertFormsToJson(formResponseData);
                console.log("formName-----------",formName)
                console.log("convertedForms-----------",convertedForms)
                
                const initialVisibility = {};
                convertedForms.forEach(field => {
                    // initialVisibility[field.name] = field.name !== "termtype"; // hide `termtype` by default
                    
                    if (field.name === "termtype") {
                        initialVisibility[field.name] = false;
                    } else if (field.name === "loantype" && isCreate) {
                        initialVisibility[field.name] = false;
                    } else if (field.name === "productid" && isEdit==true && formName == "createloanproducts") {
                        field.disabled = true;
                        initialVisibility[field.name] = true;
                    } else if (field.name === "productid" && isCreate==true && formName == "createloanproducts") {
                        console.log("fieldddd-----------",field)
                        field.maxLength = 3;
                        initialVisibility[field.name] = true;
                    } else if (field.name === "productid" && (isCreate==true || isEdit==true) && isLoanProduct==true && formName == "createloantypes") {
                        field.disabled = true;
                        initialVisibility[field.name] = true;
                    } else if (field.name === "langID" && (isEdit==true) && formName == "createlangtags") {
                        field.disabled = true;
                        initialVisibility[field.name] = true;
                    } else if (field.name === "langID" && formName == "createlanguage") {
                        field.maxLength = 2;
                        initialVisibility[field.name] = true;
                    } else if (field.name === "bankcode" && formName == "createloanbankcodes") {
                        field.maxLength = 3;
                        initialVisibility[field.name] = true;
                    } else if (field.name === "loancurr" && isEdit == true && formName == "createloancurrmsg") {
                        field.disabled = true;
                        initialVisibility[field.name] = true;
                    } else {
                        initialVisibility[field.name] = true;
                    }
                });
                
                console.log("convertedForms---------",convertedForms)
                setFields(convertedForms);
                setVisibleFields(initialVisibility);
                
                dispatch(setFormData({ formName, data: convertedForms }));
            } catch (error) {
                console.error("Failed to fetch form data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchForm();
    }, [dispatch, formName]);

    useEffect(() => {
        if (fields.length > 0) {
            setFormValues(prev => ({
                ...prev,
                ...initialValues
            }));
        }
    }, [fields, initialValues]);

    useEffect(() => {
        if (loanTerms && loanTerms.length > 0 && loanType !== "approval" ) {
            setVisibleFields(prev => ({
                ...prev,
                termtype: true,
            }));
        } else {
            setVisibleFields(prev => ({
                ...prev,
                termtype: false,
            }));
        }
    }, [loanTerms]);

    const handleChange = (name, value) => {
        console.log("nameeee-----------",name)
        // console.log("formNameeee-----------",formName)
        // console.log("value-----------",value)
        if (name === "selectproduct") {
            handleLoanSubProductChange(name, value);
            setFormValues(prev => ({ ...prev, [name]: value }));
        } else if (name === "paymentamount" && formName=="selectpaymenttype") {
            let val = parseFloat(value);
            if (isNaN(value) || value < 0) {
                val = ""; // Prevent negative values or NaN
            } else {
                if (formValues?.paymenttype === "full") {
                    val = Math.min(val, isGlobalPayment ? totalOutstandingAmount : selectedLoan?.outstandingamountwithlatefee);
                } else if (formValues?.paymenttype === "late") {
                    val = Math.min(val, selectedLoan?.outstandinglatefees);
                }
            }
            setFormValues(prev => ({ ...prev, [name]: val }));
        } else if (name === "paymenttype" && formName=="selectpaymenttype") {
            if (value === "full") {
                setFormValues(prev => ({ ...prev, paymentamount:isGlobalPayment ? totalOutstandingAmount : selectedLoan?.outstandingamountwithlatefee, [name]: value }));
            } else {
                setFormValues(prev => ({ ...prev, paymentamount:isGlobalPayment ? totalLateFees : selectedLoan?.outstandinglatefees, [name]: value }));
            }
        } else if (name === "loantype" && formName=="createloantypemessagetexts") {
            handleLoanTypeChange(value);
            setFormValues(prev => ({ ...prev, [name]: value }));
        } else if (name === "useraccount" && formName=="selectpaymenttype") {
            getUserExternalAcctBalance(value);
        } else {
            console.log("elseee----------------------",formValues?.paymenttype)
            setFormValues(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleValidation = () => {
        const newErrors = {};
        fields.forEach((field) => {
            const { name, validation } = field;
            if (validation?.required && !formValues[name]) {
                newErrors[name] = `${field.label} is required`;
            }
        });
        console.log("newErrors-----------",newErrors)
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            onSubmit(formValues);
        }
    };

    const parseOptions = (options) => {
        return JSON.parse(options)
    };

    const renderField = (field) => {
        const { type, name, label, options, disabled, placeholder } = field;

        if (!visibleFields[name]) return null;

        const value = formValues[name] || "";

        switch (type) {
        case "text":
        case "email":
        case "number":
        case "date":
            return (
                <div className="textfield-container d-flex" style={{ alignItems:'center' }}>
                    {/* <InputLabel className="label-header" sx={{
                        fontWeight: '800', 
                        lineHeight: '33.6px',
                        color: '#6b7280',
                        fontFamily: 'Nunito',
                        fontSize: '14px',
                        fontStyle: 'normal',
                    }}>
                        {label}
                    </InputLabel> */}

                    <CustomTextField
                        key={name}
                        type={type}
                        label={label}
                        value={value}
                        onChange={(e) => handleChange(name, e.target.value)}
                        placeholder={placeholder}
                        disabled={disabled}
                        error={!!errors[name]}
                        helperText={errors[name]}
                        fullWidth
                        margin="normal"
                        inputProps={{ maxLength: field.maxLength || undefined, min: type == "number" ? 0 : null, step: type === "number" ? "any" : undefined }}
                        sx={{
                            margin:"0px",
                            width: "100%",
                            borderRadius: "4px",
                            fontFamily: "Inter",
                            fontSize: "12px", 
                            background: "white",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            marginBottom: "4px",
                            marginTop: "0px",
                            lineHeight:'50px',
                            '& .MuiInputBase-root': {
                                maxHeight: "50px", 
                                fontSize: "12px", 
                            },
                        }}
                    />

                    {
                        field?.formgroup == "Message Texts" && 
                        <Button onClick={() => verifyLangTagId(value)} variant="contained" size="medium" sx={{ fontSize:'10px', marginLeft:'8px', marginTop:'10px' }} >
                            Verify
                        </Button>
                    }
                </div>
            );

        case "select":
            return (
                <FormControl
                    sx={{
                        borderRadius: "4px",
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        margin: "auto",
                        marginBottom: "7px",
                    }}
                >
                    <Autocomplete
                        key={name}
                        style={{ width: "100%", paddingRight: "0px", paddingLeft: "0px" }}
                        options={options || []}
                        getOptionLabel={(option) => option.label || ""}
                        isOptionEqualToValue={(option, value) => option.value === value}
                        value={options?.find(opt => opt.value === value) || null}
                        onChange={(_, newVal) => handleChange(name, newVal?.value || "")}
                        renderOption={(props, option) => (
                            <li {...props} key={option.value}>
                                {option.label}
                            </li>
                        )}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            error={!!errors[name]}
                            helperText={errors[name]}
                            fullWidth
                            margin="normal"
                            sx={{
                                width: "100%",
                                borderRadius: "4px",
                                fontFamily: "Inter",
                                fontSize: "16px",
                                background: "white",
                                marginBottom: "4px",
                                '& .MuiInputBase-root': {
                                  maxHeight: "50px",
                                  // padding: "6px 10px",
                                  paddingRight: "32px !important",
                                  fontSize: "18px", // Reduced font size of input text
                                },
                                '& label.Mui-focused, & label.MuiInputLabel-shrink': {
                                    top: 0,
                                    fontSize: '18px !important',
                                },
                                '& input': {
                                    padding: '15px 12px',
                                    fontSize: '16px',
                                    lineHeight: '50px !important',
                                },
                            }}
                            InputLabelProps={{
                                style: {
                                  fontSize: "15px",
                                  textAlign: "center",
                                },
                            }}
                        />
                        )}
                        disabled={disabled}
                    />

                    {name=="useraccount" && formName=="selectpaymenttype" && <Box className="loans-curr-balance-container">
                        Current Balance: {externalBalance}
                    </Box>}
                </FormControl>
            );

            case "multiselect":
                console.log("optionsssss===================",options)

                return (
                    <FormControl
                        sx={{
                            borderRadius: "4px",
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            margin: "auto",
                            marginBottom: "7px",
                        }}
                    >
                        <Autocomplete
                            multiple
                            key={name}
                            options={parseOptions(options) || []}
                            getOptionLabel={(option) => option.label || ""}
                            isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                            }
            
                            // VALUE MUST ALWAYS BE ARRAY
                            value={
                                Array.isArray(value)
                                    ? parseOptions(options).filter(opt => value.includes(opt.value))
                                    : []
                            }
            
                            onChange={(_, newVals) =>
                                handleChange(
                                    name,
                                    newVals ? newVals.map(v => v.value) : []
                                )
                            }
            
                            renderOption={(props, option) => (
                                <li {...props} key={option.value}>
                                    {option.label}
                                </li>
                            )}
            
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={label}
                                    error={!!errors[name]}
                                    helperText={errors[name]}
                                    fullWidth
                                    margin="normal"
                                />
                            )}
            
                            disabled={disabled}
                        />
                    </FormControl>
                );

        case "radio":
            // console.log("outstandingamountwithlatefee===================",selectedLoan?.outstandingamountwithlatefee)
            // console.log("outstandinglatefees===================",selectedLoan?.outstandinglatefees)
            return (
                <FormControl key={name} component="fieldset" margin="normal">
                    <FormLabel component="legend" sx={{ fontSize: "16px", mb: 1 }}>{label}</FormLabel>
                    <RadioGroup
                        row
                        value={value}
                        onChange={(e) => handleChange(name, e.target.value)}
                    >
                        {(Array.isArray(options) ? options : parseOptions(options)).map((opt) => (
                            <FormControlLabel
                                key={opt.value}
                                value={opt.value}
                                control={<Radio sx={{ p: 0.5 }} />}
                                label={opt.label}
                                disabled={
                                    (opt.value === "full" && selectedLoan?.outstandingamountwithlatefee <= 0) ||
                                    (opt.value === "late" && (selectedLoan?.outstandinglatefees <= 0 || totalLateFees <= 0))
                                }
                                sx={{
                                    mr: 2,
                                    '& .MuiFormControlLabel-label': {
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        fontFamily: 'Inter',
                                        color: '#374151', // Tailwind's gray-700 for example
                                    },
                                }}
                            />
                        ))}
                    </RadioGroup>
                    {errors[name] && <p className="error-text">{errors[name]}</p>}
                </FormControl>
            );

        case "toggle":
            return (
                <FormControlLabel
                    key={name}
                    control={
                        <Switch
                            checked={!!value}
                            onChange={(e) => handleChange(name, e.target.checked)}
                        />
                    }
                    label={label}
                    sx={{ mt: 2 }}
                />
            );

        default:
            return null;
        }
    };

    const groupFieldsByFormGroup = (fields) => {
        const groups = {};
    
        fields.forEach((field) => {
            const group = field.formgroup || "General";
            if (!groups[group]) groups[group] = [];
            groups[group].push(field);
        });
    
        return groups;
    };

    return (
        <>
            {isLoading ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            overflow: "hidden",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <Box display="flex" flexWrap="wrap" gap={2}>
                                {(() => {
                                    const groupedFields = {};

                                    fields.forEach((field) => {
                                        if (!visibleFields[field.name]) return;
                                        const group = field.formgroup || "General";
                                        if (!groupedFields[group]) groupedFields[group] = [];
                                        groupedFields[group].push(field);
                                    });

                                    return Object.entries(groupedFields).map(([groupName, groupFields]) => (
                                        <Box key={groupName} flex={1} minWidth="300px" sx={{ paddingRight: 1 }}>
                                            <Box
                                                fontWeight="bold"
                                                fontSize="20px"
                                                mb={2}
                                                sx={{ color: '#4B5563', fontFamily: 'Nunito' }}
                                            >
                                                {groupName}
                                            </Box>
                                            {groupFields.map((field) => (
                                                <Box key={field.name} sx={{ mb: 3 }}>
                                                    {renderField(field)}
                                                </Box>
                                            ))}
                                        </Box>
                                    ));
                                })()}
                            </Box>

                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={loading}
                                className="fs-size-12 paiy-green text-white mt-2 custom-loans-form-submit"
                                sx={{ alignSelf: 'flex-start' }}
                            >
                                {loading ? <CircularProgress size={20} color="inherit" /> : buttonText}
                            </Button>
                        </Box>
                    </form>
                    // <form onSubmit={handleSubmit}>
                    //     <Box display="flex" flexDirection="column" gap={1}>
                    //         {fields.map((field) => renderField(field))}

                    //         <Button
                    //             type="submit"
                    //             variant="contained"
                    //             color="primary"
                    //             disabled={loading}
                    //             className="fs-size-12 paiy-green text-white mt-2 custom-loans-form-submit"
                    //         >
                    //             {loading ? <CircularProgress size={20} color="inherit" /> : buttonText}
                    //         </Button>
                    //     </Box>
                    // </form>
                )
            }
        </>
    );
};

export default CustomLoansForm;